import { render } from "./CategoryList.vue?vue&type=template&id=335b7f4e"
import script from "./CategoryList.vue?vue&type=script&lang=js"
export * from "./CategoryList.vue?vue&type=script&lang=js"

import exportComponent from "D:\\laragon\\www\\moesanpan_pos_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__